import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  align-items: center;
  justify-content: center;
`;

export default Container;
